import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import sendEvent from "@gcloud-npm/utils.metrics.send-ga-component-event";
import { Workers, WORKER_TYPES } from "@gcloud-npm/utils.worker-client";
import SecureStorage from "@gcloud-npm/utils.secure.local-storage";
let CUSTO_WORKER = null;
const REQUEST_IN_FLIGHT = new Map();
const REQUEST_CACHE = new Map();
const REQUEST_CACHE_TTL_MS = 60 * 1000;
const hasUsableValue = (value) => value !== null && typeof value !== "undefined";
const isValidRequestKey = (value) =>
  typeof value === "string" && value.length > 0 && value !== "undefined";

const cloneData = (data) => {
  try {
    return JSON.parse(JSON.stringify(data));
  } catch (e) {
    return data;
  }
};

const pruneRequestCache = () => {
  const now = Date.now();
  REQUEST_CACHE.forEach((entry, key) => {
    if (!entry || now - entry.createdAt > REQUEST_CACHE_TTL_MS) {
      REQUEST_CACHE.delete(key);
    }
  });
};

const hasCookie = (cookieName) => {
  if (typeof document === "undefined" || !cookieName) return false;
  const escaped = cookieName.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const regex = new RegExp(`(?:^|;\\s*)${escaped}=`);
  return regex.test(document.cookie || "");
};

const getPersistedInfo = () => {
  try {
    const secureStorage = new SecureStorage();
    return secureStorage.getItem("ts") || {};
  } catch (e) {
    return {};
  }
};

const mergeContextWithPersisted = (context = {}, persistedInfo = {}) => ({
  ...context,
  userName: persistedInfo.userName || context.userName || "",
  userType: persistedInfo.userType || context.userType || "",
  userIdPartyHash: persistedInfo.userIdPartyHash || context.userIdPartyHash || "",
  userCUCFijoHash: persistedInfo.userCUCFijoHash || context.userCUCFijoHash || "",
  userCUCMovilHash: persistedInfo.userCUCMovilHash || context.userCUCMovilHash || "",
  userCUCPrepagoHash: persistedInfo.userCUCPrepagoHash || context.userCUCPrepagoHash || "",
});

const getRequestKey = ({ name, kind, context, userPq, userPo, userPromosIncompatible, userRecom, customer }) => {
  try {
    return JSON.stringify({
      name: name || "",
      kind: kind || "activity",
      idp: context?.userIdPartyHash || "",
      cuc: context?.userCUCFijoHash || "",
      cucm: context?.userCUCMovilHash || "",
      cucp: context?.userCUCPrepagoHash || "",
      pageSegment: context?.pageSegment || "",
      userPq: userPq || {},
      userPo: userPo || {},
      userPromosIncompatible: userPromosIncompatible || {},
      userRecom: userRecom || {},
      customer: customer || {},
    });
  } catch (e) {
    return null;
  }
};
/*IMPORTS*/
 
/* DYNAMIC COMPONENTS ENDS   */
/*
 - recibo las props ya pedidas desde pagina
 - recibo el componente ya definido, incluimos lo del scroll
 - permitir modelar el fake para las medias
 
- la excepción radica en: (importante pedir esa info cuando CONTEXT SE HAYA ACUTALIZADO POR PRIMERA VEZ Y TENER LLOS HAEHS DE CLIENTE)
 -> qa, queremos que repita en cliente su propia info para tener la foto actualizada (tanto)
 -> al prod vamos a probar la idea de renderizar siempre la no cliente, y rehidratar con la cliente aver que tal va
*/

class CustomizerComponent extends Component {
  constructor(props) {
    super(props);
    this.printEventSended = false;
    const { componentProps } = props;
    const allowEdit = `${process.env.NEXT_PUBLIC_ALLOW_EDIT}` === "true";
    this.creativityInitialInfo = null;
    this.initCreativityRequest = false;
    this.state = {
      componentProps,
      allowEdit,
      finalFetch: false,
      draftChanges: 0,
    };
  }
 
  requestActivity = async ({ context, userPq, userPo, userRecom, userPromosIncompatible, name, customer }) => {
    const { allowEdit } = this.state;
    const { kind } = this.props;
 
    try {
      if(!CUSTO_WORKER){
        CUSTO_WORKER =await Workers.getWorker(WORKER_TYPES.CUSTO);
      }

      pruneRequestCache();

      const dedupeKey = getRequestKey({
        name,
        kind,
        context,
        userPq,
        userPo,
        userPromosIncompatible,
        userRecom,
        customer,
      });
      const canUseDedupe = isValidRequestKey(dedupeKey);

      if (canUseDedupe && REQUEST_CACHE.has(dedupeKey)) {
        const cachedEntry = REQUEST_CACHE.get(dedupeKey);
        const cachedData = cloneData(cachedEntry?.data);
        if (hasUsableValue(cachedData)) {
          if (allowEdit) {
            this.creativityInitialInfo = cachedData;
          }
          this.setState({
            componentProps: cachedData,
            finalFetch: true,
          });
          return;
        }
        REQUEST_CACHE.delete(dedupeKey);
      }

      let requestPromise = canUseDedupe
        ? REQUEST_IN_FLIGHT.get(dedupeKey)
        : null;
      if (!requestPromise) {
        requestPromise = Promise.resolve(CUSTO_WORKER.getByName({
          name,
          context,
          kind,
          userPq,
          customer,
          userPromosIncompatible,
          userPo,
          userRecom,
          custoVersion: 3,
        }))
          .then((response) => {
            if (canUseDedupe && hasUsableValue(response)) {
              REQUEST_CACHE.set(dedupeKey, {
                data: response,
                createdAt: Date.now(),
              });
            }
            return response;
          })
          .finally(() => {
            if (canUseDedupe) {
              REQUEST_IN_FLIGHT.delete(dedupeKey);
            }
          });
        if (canUseDedupe) {
          REQUEST_IN_FLIGHT.set(dedupeKey, requestPromise);
        }
      }

      const componentProps = await requestPromise;
      const normalizedResponse = cloneData(componentProps);
      const finalComponentProps = hasUsableValue(normalizedResponse)
        ? normalizedResponse
        : this.state.componentProps;

      if (allowEdit && hasUsableValue(normalizedResponse)) {
        this.creativityInitialInfo = normalizedResponse;
      }
      this.setState({
        componentProps: finalComponentProps,
        finalFetch: true,
      });
    } catch (err) {
      this.setState({ finalFetch: true });
    }
  };

  componentDidMount = () => {
    if (this.initCreativityRequest) return;

    const { name, forceReload, context } = this.props;
    if (!name) {
      this.setState({ finalFetch: true });
      return;
    }

    const isScLogged = hasCookie("sc.logged");
    if (!isScLogged && !forceReload) {
      this.setState({ finalFetch: true });
      return;
    }

    const persistedInfo = getPersistedInfo();
    const contextToUse = mergeContextWithPersisted(context, persistedInfo);

    if (!contextToUse?.environment?.custo) {
      this.setState({ finalFetch: true });
      return;
    }

    this.initCreativityRequest = true;
    this.requestActivity({
      context: contextToUse,
      userPq: persistedInfo.userPq || {},
      customer: persistedInfo.customer || {},
      userPo: persistedInfo.userPo || {},
      userRecom: persistedInfo.userRecom || {},
      userPromosIncompatible: persistedInfo.userPromosIncompatible || {}, 
      name,
    });
  };
 
  componentDidUpdate(prevProps, prevState) {
    const { componentName, name } = this.props;
    const { componentProps, allowEdit } = this.state;
    const emptyContent =
      componentProps &&
      componentProps.creativityName &&
      componentProps.creativityName === "CMS-EMPTY-CONTENT";
    const hasTuringRecom =
      componentProps &&
      componentProps.taggingInfo &&
      componentProps.taggingInfo.componentPerso &&
      componentProps.taggingInfo.componentPerso !== "none";
    const { finalFetch } = this.state;
    if (
      hasTuringRecom &&
      !emptyContent &&
      finalFetch &&
      !this.printEventSended &&
      componentProps &&
      componentProps.taggingInfo
    ) {
      this.printEventSended = true;
      const { taggingInfo } = componentProps;
      sendEvent({
        ...taggingInfo,
        componentPerso: JSON.stringify(taggingInfo.componentPerso),
        eventType: "print-success",
        componentName,
      });
    }
  }
  /*METHODS*/
 
  render() {
    try {
      const { Component, skeletonClassName, componentName, editMode } = this.props;
      const { finalFetch, allowEdit } = this.state;
      let { componentProps } = this.state;
      const { commonProps } = this.props;
  
      if (!componentProps) {
        return null;
      }
  
      const { taggingInfo, creativityId } = componentProps;
      const finalTaggingInfo = {
        ...taggingInfo,
        componentName,
      };
  
      const isVisibleCreativity =
        componentProps &&
        (!componentProps.display || componentProps.display !== "none");
      if (!isVisibleCreativity && finalFetch) {
        return null;
      }
  
      if (
        isVisibleCreativity &&
        componentProps &&
        Object.keys(componentProps).length > 0
      ) {
        let custoObjectInfo = null;
        if (allowEdit && editMode) {
          custoObjectInfo = this.createCustoDescObject();
          const draft = getFromSession(creativityId);
          if (draft) {
            componentProps = draft;
          }
        }
  
        return (
          <Component
            {...componentProps}
            {...commonProps}
            taggingInfo={finalTaggingInfo}
            custoObjectInfo={custoObjectInfo}
            skeletonClassName={
              !finalFetch ? `skeleton ${skeletonClassName}` : "skeleton loaded"
            }
            contentLoaded={finalFetch}
            finalFetch={finalFetch}
          />
        );
      }
 
    return <></>;
    } catch(e) {
      console.log("[CUSTOMIZER-COMPONENT]", e)
      return <></>
    }


  }
}
 
const mapStateToProps = (state) => ({
  context: state.main.context,
  editMode: state.main.editMode,
});
 
// const mapDispatchToProps = (dispatch) => ({
//   addModal: (data) => dispatch(modalActions.addModal(data)),
// });
 
CustomizerComponent.propTypes = {
  skeletonClassName: PropTypes.string,
  forceReload: PropTypes.bool,
  // propiedades adicionales que necesita el compo hijo para pintar tanto en logado como en no logado
  commonProps: PropTypes.object,
  kind: PropTypes.string,
};
 
CustomizerComponent.defaultProps = {
  skeletonClassName: "",
  commonProps: {},
  forceReload: false,
  componentProps: {},
  kind: "activity",
};
 
export default connect(mapStateToProps, null)(CustomizerComponent);
